import TableCountryScanCount from './table-country-scan-count.container';

export default TableCountryScanCount;
